var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-5 display-4 text-uppercase text-muted"},[_vm._v("loading")]),_c('p',{staticClass:"text-muted"},[_c('Icon',{attrs:{"i":"spinner","spin":""}}),_vm._v(" one moment...")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }